import { lazy, Suspense, useEffect } from "react";
import { Switch, Route, useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";
import i18n from "../translation";

const SUPPORTED_LANGS = ["en","es", "it", "de", "fr"];

const Router = () => {
  const location = useLocation();

  useEffect(() => {
    // Detect language from URL: /es, /it, /de, /fr
    const langMatch = location.pathname.match(/^\/(en|es|it|de|fr)(\/|$)/);
    if (langMatch) {
      i18n.changeLanguage(langMatch[1]);
    } else {
      i18n.changeLanguage("en");
    }
  }, [location.pathname]);

  return (
    <Suspense fallback={null}>
      <Styles />
      <Header />
      <Switch>
        {routes.map((routeItem) => {
          // Add language prefix to each route
          return SUPPORTED_LANGS.concat(["" /* default/en */]).map((lang) => {
            const prefix = lang ? `/${lang}` : "";
            return (
              <Route
                key={prefix + routeItem.component}
                path={Array.isArray(routeItem.path)
                  ? routeItem.path.map((p) => prefix + p)
                  : prefix + routeItem.path}
                exact={routeItem.exact}
                component={lazy(() => import(`../pages/${routeItem.component}`))}
              />
            );
          });
        })}
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default Router;
